import { AnyAction } from '@reduxjs/toolkit'
import { Moment } from 'moment'
import { Action } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import { IActivityCategory } from '../interface/IActivity'
import {
  ICreateWaitingCustomer,
  ICreateWaitingCustomerResponse,
} from '../interface/ICreateWaitingCustomer'
import { IMenuCategory } from '../interface/IMenuCategory'
import { IWaitingCustomer } from '../interface/IWaitingCustomer'

import Client from './../Client/Client'
import IWaitingListState from './IWaitingListState'

export const GET_WAITING_CUSTOMERS_SUCCESS = 'GET_WAITING_CUSTOMERS_SUCCESS'
export const GET_WAITING_CUSTOMERS_FAILURE = 'GET_WAITING_CUSTOMERS_FAILURE'

export const DELETE_WAITING_CUSTOMERS_REQUEST =
  'DELETE_WAITING_CUSTOMERS_REQUEST'
export const DELETE_WAITING_CUSTOMERS_SUCCESS =
  'DELETE_WAITING_CUSTOMERS_SUCCESS'
export const DELETE_WAITING_CUSTOMERS_FAILURE =
  'DELETE_WAITING_CUSTOMERS_FAILURE'

export const UNDO_DELETE_WAITING_CUSTOMERS_REQUEST =
  'UNDO_DELETE_WAITING_CUSTOMERS_REQUEST'
export const UNDO_DELETE_WAITING_CUSTOMERS_SUCCESS =
  'UNDO_DELETE_WAITING_CUSTOMERS_SUCCESS'
export const UNDO_DELETE_WAITING_CUSTOMERS_FAILURE =
  'UNDO_DELETE_WAITING_CUSTOMERS_FAILURE'

export const SET_LOADING_TRUE = 'SET_LOADING_TRUE'

export const CREATE_WAITING_CUSTOMER_REQUEST = 'CREATE_WAITING_CUSTOMER_REQUEST'
export const CREATE_WAITING_CUSTOMER_SUCCESS = 'CREATE_WAITING_CUSTOMER_SUCCESS'
export const CREATE_WAITING_CUSTOMER_FAILURE = 'CREATE_WAITING_CUSTOMER_FAILURE'

export const UPDATE_WAITING_CUSTOMER_REQUEST = 'UPDATE_WAITING_CUSTOMER_REQUEST'
export const UPDATE_WAITING_CUSTOMERS_SUCCESS =
  'UPDATE_WAITING_CUSTOMERS_SUCCESS'
export const UPDATE_WAITING_CUSTOMERS_FAILURE =
  'UPDATE_WAITING_CUSTOMERS_FAILURE'

export const GET_EXTRA_ACTIVITIES = 'GET_EXTRA_ACTIVITIES'
export const EXTRA_ACTIVITIES_LOADING = 'EXTRA_ACTIVITIES_LOADING'

export const MENU_LOADING = 'MENU_LOADING'
export const GET_MENU_CATEGORIES_SUCCESS = 'GET_MENU_CATEGORIES_SUCCESS'

export const getWaitingCustomers = (
  startDate: moment.Moment | undefined,
  endDate: moment.Moment | undefined,
) => {
  return (dispatch: ThunkDispatch<IWaitingListState, undefined, AnyAction>) => {
    dispatch({
      type: SET_LOADING_TRUE,
    })

    return Client.getWaitingCustomers(startDate, endDate).then(
      (waitingCustomers: any[]) => {
        dispatch(getWaitingCustomersSuccess(waitingCustomers))
      },
      message => {
        dispatch(getWaitingCustomersFailure(message))
      },
    )
  }
}

const getWaitingCustomersSuccess = (waitingCustomers: IWaitingCustomer[]) => {
  return {
    type: GET_WAITING_CUSTOMERS_SUCCESS,
    waitingCustomers,
  }
}
const getWaitingCustomersFailure = (message: string) => {
  return {
    type: GET_WAITING_CUSTOMERS_FAILURE,
    message,
  }
}

export const deleteWaitingCustomer = (waitingCustomer: IWaitingCustomer) => {
  return (dispatch: ThunkDispatch<IWaitingListState, undefined, any>) => {
    dispatch(deleteWaitingCustomersRequest())

    return Client.deleteWaitingCustomer(waitingCustomer.id).then(
      message => {
        dispatch(deleteWaitingCustomersSuccess(message.status))
      },
      message => {
        dispatch(deleteWaitingCustomersFailure(message.status))
      },
    )
  }
}

const deleteWaitingCustomersRequest = () => {
  return {
    type: DELETE_WAITING_CUSTOMERS_REQUEST,
  }
}

const deleteWaitingCustomersSuccess = (waitingCustomer: IWaitingCustomer) => {
  return {
    type: DELETE_WAITING_CUSTOMERS_SUCCESS,
    waitingCustomer,
  }
}

const deleteWaitingCustomersFailure = (statusCode: string) => {
  return {
    type: DELETE_WAITING_CUSTOMERS_FAILURE,
    statusCode,
  }
}

export const undoDeleteWaitingCustomer = (
  waitingCustomer: IWaitingCustomer,
) => {
  return (dispatch: ThunkDispatch<IWaitingListState, undefined, any>) => {
    dispatch(undoDeleteWaitingCustomersRequest())

    return Client.undoDeleteWaitingCustomer(waitingCustomer.id).then(
      message => {
        dispatch(undoDeleteWaitingCustomersSuccess(message.status))
      },
      message => {
        dispatch(undoDeleteWaitingCustomersFailure(message.status))
      },
    )
  }
}

const undoDeleteWaitingCustomersRequest = () => {
  return {
    type: UNDO_DELETE_WAITING_CUSTOMERS_REQUEST,
  }
}

const undoDeleteWaitingCustomersSuccess = (
  waitingCustomer: IWaitingCustomer,
) => {
  return {
    type: UNDO_DELETE_WAITING_CUSTOMERS_SUCCESS,
    waitingCustomer,
  }
}

const undoDeleteWaitingCustomersFailure = (statusCode: string) => {
  return {
    type: UNDO_DELETE_WAITING_CUSTOMERS_FAILURE,
    statusCode,
  }
}

export const createWaitingCustomer = (
  waitingCustomer: ICreateWaitingCustomer,
) => {
  return async (dispatch: ThunkDispatch<IWaitingCustomer, undefined, any>) => {
    dispatch({
      type: CREATE_WAITING_CUSTOMER_REQUEST,
    })

    await Client.createWaitingCustomer(waitingCustomer).then(
      createdWaitingCustomer => {
        return dispatch(createWaitingCustomersSuccess(createdWaitingCustomer))
      },
      () => dispatch(createWaitingCustomersFailure()),
    )
  }
}

const createWaitingCustomersSuccess = (
  waitingCustomer: ICreateWaitingCustomerResponse,
) => {
  return {
    type: CREATE_WAITING_CUSTOMER_SUCCESS,
    waitingCustomer,
  }
}
const createWaitingCustomersFailure = () => {
  return {
    type: CREATE_WAITING_CUSTOMER_FAILURE,
  }
}

export const updateWaitingCustomers = (
  waitingCustomers: IWaitingCustomer[],
) => {
  return (dispatch: ThunkDispatch<IWaitingCustomer, undefined, any>) => {
    dispatch({
      type: UPDATE_WAITING_CUSTOMER_REQUEST,
    })

    return Client.updateWaitingCustomers(waitingCustomers).then(
      (updatedWaitingCustomers: IWaitingCustomer[]) => {
        dispatch(updateWaitingCustomersSuccess(updatedWaitingCustomers))
      },
      () => dispatch(updateWaitingCustomersFailure()),
    )
  }
}

const updateWaitingCustomersSuccess = (
  waitingCustomers: IWaitingCustomer[],
) => {
  return {
    type: UPDATE_WAITING_CUSTOMERS_SUCCESS,
    waitingCustomers,
  }
}
const updateWaitingCustomersFailure = () => {
  return {
    type: UPDATE_WAITING_CUSTOMERS_FAILURE,
  }
}

export interface MenuLoading extends Action<typeof MENU_LOADING> {}

export function menuLoading(): MenuLoading {
  return {
    type: MENU_LOADING,
  }
}

function getMenuCategoriesSuccess(categories: any) {
  return {
    type: GET_MENU_CATEGORIES_SUCCESS,
    categories,
  }
}

export function getMenuCategories(establishmentId: string) {
  return (dispatch: any) => {
    dispatch(menuLoading())

    Client.getMenuCategories(establishmentId).then(
      (response: IMenuCategory[]) => {
        dispatch(getMenuCategoriesSuccess(response))
      },
    )
  }
}

function activitiesLoading() {
  return {
    type: EXTRA_ACTIVITIES_LOADING,
  }
}

function getActivitiesSuccess(categories: IActivityCategory[]) {
  return {
    type: GET_EXTRA_ACTIVITIES,
    payload: {
      categories,
    },
  }
}

export function getActivityCategories(establishmentId: string) {
  return (dispatch: any) => {
    dispatch(activitiesLoading())

    Client.getActivitySelect(establishmentId).then(categories => {
      dispatch(getActivitiesSuccess(categories))
    })
  }
}
